goog.provide('el8.appchart.refpanel.providers');

goog.require('el8.app.shared.network.viewEditConnection');
goog.require('el8.appchart.dialog.referralHistory');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.appchart.providers.main');
goog.require('el8.app.shared.clickItemOpts');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.ptProviders');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.refpanel.providers');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.uiwidget.confirm');
goog.require('el8.util.consts');

el8.appchart.refpanel.providers = (function() {

    var clickTexts;

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('providers');

    var _renderFn = function() {
        clickTexts = {};

        var $section = $('#provider-section');
        var $list = $('#providers-summary');

        $section.removeClass('el8Loading');
        var mainProviders = el8.ptdata.ptProviders.allMain();

        $list.html(
            el8.template.appchart.refpanel.providers.summary({
                items: mainProviders.map(el8.model.toSoyMapFn)
            })
        );

        $('.treating-note-field', $list).each(function(index, elt) {
            var $elt = $(elt);
            var id = $elt.data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            clickTexts[id] = initTreatmentReasonField($elt, provider);
        });

        // refresh the list of sortable items
        $section.sortable('refresh');

        reportOnFirstLoad();
    };

    var _renderCareTeamFn = function() {
        clickTexts = {};

        var $section = $('#care-team-section');
        var $list = $('#care-team-summary');

        $section.removeClass('el8Loading');
        var careTeamMembers = el8.ptdata.careTeamProviders.sortedByGroup({
            indicatePracticeUsers: true,
            indicateCurrentUser: true
        });
        var providerDict = el8.ptdata.ptProviders.sortedByGroup({ indicatePracticeUsers: true });
        var careTeamWithMainProviders = careTeamMembers.activeMembers.concat(providerDict.mainProviders);

        var physician_ids = [];
        careTeamWithMainProviders =
        _.filter(careTeamWithMainProviders, function(p) {
            if (!p['physicianId']) { return true; }
            if (physician_ids.indexOf(p['physicianId']) === -1) {
                physician_ids.push(p['physicianId']);
                return true;
            } else {
                return false;
            }
        });
        careTeamWithMainProviders.sort(el8.appchart.providers.main.careTeamSortFn);

        $list.html(
            el8.template.appchart.refpanel.providers.summaryCareTeam({
                items: careTeamWithMainProviders
            })
        );

        $('.care-team-note-field', $list).each(function(index, elt) {
            var $elt = $(elt);
            var id = $elt.data('id');
            var provider = el8.ptdata.careTeamProviders.getById(id);
            clickTexts[id] = initCareTeamNoteField($elt, provider);
        });
        $('.treating-note-field', $list).each(function(index, elt) {
            var $elt = $(elt);
            var id = $elt.data('id');
            var provider = el8.ptdata.ptProviders.getById(id);
            clickTexts[id] = initTreatmentReasonField($elt, provider);
        });

        reportOnFirstLoad();
    };

    var _sortSaveFn = function() {
        var lenAllMain = el8.ptdata.ptProviders.allMain().length;
        $('#providers-summary-list').find('.provider-entry').each(function(index, elt) {
            var provider = el8.ptdata.ptProviders.getById($(elt).data('id')*1);
            provider.setGroup('main');
            provider.setSortSequence(index, lenAllMain);
        });
        el8.ptdata.ptProviders.saveRankOrder();
    };

    var _initProvidersFn = function(sectionObject) {
        var container = $('#providers-section');
        sectionObject.addContainer(container);
        el8.uiwidget.collapsible({
            container: container,
            triggerElt: $('#providers-summary-header'),
            statusElt: $('#providers-summary-status')
        });
        $('#manage-providers-trigger').on('click', function() {
            el8.appchart.providers.main.show({tab: 'team'});
        });
        $('#providers-section').append(
            el8.template.appchart.refpanel.providers.addNewTrigger()
        ).removeClass('el8Loading');

        $('#providers-section').sortable({
            items: 'li.provider-entry',
            handle: '.provider-sort-handle',
            cursor: 'move',
            start: function() {
                // don't leave a displaced actions menu behind
                el8.appchart.refpanel.actionsMenu.hide();
            },
            update: function(e, ui) {
                _sortSaveFn();
            }
        });

        // Activate the links
        $('#providers-section').on('click', '.providers-summary-list-trigger',  function(event) {
            var providerId = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(providerId);
            el8.app.shared.network.viewEditConnection.show({ contactId: provider.getPhysicianId() });
            return false;

        }).on('click', '.add-treating-note',  function() {
            var $providerEntry = $(this).closest('.provider-entry');
            var providerId = $providerEntry.data('id');
            addInitTreatmentReasonField($providerEntry, providerId);
            clickTexts[providerId].setFocus();
            return false;

        }).on('click', '.more-actions-trigger',  function(evt) {
            // don't show actions menu for click on sort handle
            if ($(evt.target).hasClass('provider-sort-handle')) { return; }

            var itemId = $(this).data('id')*1;
            var ptProvider = el8.ptdata.ptProviders.getById(itemId);
            if (ptProvider) {
                var menu = getProvidersActionsMenu(ptProvider);
                el8.appchart.refpanel.actionsMenu.display(
                    $(this), ptProvider, {top: 17, left: 14}, menu
                );
            }
            return false;

        }).on('click', '.add-provider-trigger',  function(event) {
            createNewProviderForm('providers');
        });

        $(document).on('el8_refBoardChange', function() {
            for (var id in clickTexts) {
                if (clickTexts.hasOwnProperty(id)) {
                    clickTexts[id].triggerResize();
                }
            }
        });
    };

    function _initCareTeamFn(sectionObject) {
        var container = $('#care-team-section');
        sectionObject.addContainer(container);
        el8.uiwidget.collapsible({
            container: container,
            triggerElt: $('#care-team-summary-header'),
            statusElt: $('#care-team-summary-status')
        });
        $('#care-team-section').append(
            el8.template.appchart.refpanel.providers.careTeamTriggerSet()
        ).removeClass('el8Loading');

        $('.manage-care-team-trigger').on('click', function() {
            el8.appchart.providers.main.show({tab: 'team'});
        });

        // Activate the links
        $('#care-team-section').on('click', '.care-team-summary-list-trigger',  function(event) {
            var providerId = $(this).closest('.care-team-entry').data('id');
            var provider = el8.ptdata.careTeamProviders.getById(providerId);
            el8.app.shared.network.viewEditConnection.show({ contactId: provider.getPhysicianId() });
            return false;
        }).on('click', '.providers-summary-list-trigger',  function(event) {
            var providerId = $(this).closest('.provider-entry').data('id');
            var provider = el8.ptdata.ptProviders.getById(providerId);
            el8.app.shared.network.viewEditConnection.show({ contactId: provider.getPhysicianId() });
            return false;


        }).on('click', '.add-care-team-provider-note',  function() {
            var $providerEntry = $(this).closest('.care-team-entry');
            var providerId = $providerEntry.data('id');
            addInitCareTeamNoteField($providerEntry, providerId);
            clickTexts[providerId].setFocus();
            return false;
        }).on('click', '.add-treating-note',  function() {
            var $providerEntry = $(this).closest('.provider-entry');
            var providerId = $providerEntry.data('id');
            addInitTreatmentReasonField($providerEntry, providerId);
            clickTexts[providerId].setFocus();
            return false;

        }).on('click', '.more-actions-trigger',  function(evt) {
            var itemId = $(this).data('id')*1;
            var ptProvider = el8.ptdata.ptProviders.getById(itemId);
            if (ptProvider) {
                var menu = getProvidersActionsMenu(ptProvider);
                el8.appchart.refpanel.actionsMenu.display(
                    $(this), ptProvider, {top: 17, left: 14}, menu
                );
            }
            return false;
        }).on('click', '.more-actions-care-team-trigger',  function(evt) {
            var itemId = $(this).data('id')*1;
            var provider = el8.ptdata.careTeamProviders.getById(itemId);
            if (provider) {
                var menu = getCareTeamActionsMenu(provider);
                el8.appchart.refpanel.actionsMenu.display(
                    $(this), provider, {top: 17, left: 14}, menu
                );
            }
            return false;
        }).on('click', '.add-provider-trigger',  function(event) {
            createNewProviderForm('care-team');
        });
    }

    var that = new el8.appchart.refpanel.RefPanelSection({
        initFn: function() {
            if (el8Globals.FEATURES.PLR4Everyone) {
                _initCareTeamFn(that);
            } else {
                _initProvidersFn(that);
            }
        },
        loadFn: function(successCb) {
            if (el8Globals.FEATURES.PLR4Everyone) {
                el8.ptdata.careTeamProviders.softLoad();
                el8.ptdata.ptProviders.softLoad();
            } else {
                el8.ptdata.ptProviders.softLoad();
            }
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptProviders,
                events: [{
                    eventName: 'all',
                    fn: function(eventName) {
                        if (eventName === 'MOVED_MAIN') { return; }
                        if (el8Globals.FEATURES.PLR4Everyone) {
                            _renderCareTeamFn.apply(this, arguments);
                        } else {
                            _renderFn.apply(this, arguments);
                        }
                    }
                }],
                renderFn: function() {
                    if (el8Globals.FEATURES.PLR4Everyone) {
                        _renderCareTeamFn();
                    } else {
                        _renderFn();
                    }
                }
            },
            {
                entitySet: el8.ptdata.careTeamProviders,
                events: [{
                    eventName: 'all',
                    fn: function(eventName) {
                        if (el8Globals.FEATURES.PLR4Everyone) {
                            _renderCareTeamFn.apply(this, arguments);
                        } else {
                            _renderFn.apply(this, arguments);
                        }
                    }
                }],
                renderFn: function() {
                    if (el8Globals.FEATURES.PLR4Everyone) {
                        _renderCareTeamFn();
                    } else {
                        _renderFn();
                    }
                }
            }
        ]
    });

    return that;

    function createNewProviderForm(parent) {
        $('.add-provider-trigger', $('#' + parent + '-section')).hide();
        var $container = $('#' + parent + '-form-holder');
        $container.html(
            el8.template.appchart.refpanel.providers.addNewForm()
        );

        var form = new el8.uiwidget.Form({
            container: $('.new-provider-form', $container),
            buttonElt: $('.new-provider-form-buttons', $container),
            fields: [
                {
                    name: 'name',
                    selector: '.name-field',
                    infoText: "Enter a provider's name..",
                    clickItemOpts: el8.app.shared.clickItemOpts.physicians({
                        urlParams: { nouser: 1 },
                        newContactCb: function(contact) {
                            el8.ptdata.ptProviders.createMainProvider({
                                physicianId: contact.getId(),
                                successCb: function(item) {
                                    hideNewProviderForm(item, parent);
                                }
                            });
                        },
                        /* We don't want to show existing providers on focus for this AC, because by
                         * defn, we're looking to add new providers to the list - explicit override */
                        autoSuggestOnFocus: false
                    })
                },
                {
                    name: 'specialties',
                    selector: ':input[name="specialties"]',
                    listeditorOpts: function() {
                        var leOpts = el8.appshared.listeditorOpts.medicalSpecialties();
                        return $.extend(leOpts, {
                            list: $('.specialties-list', $container),
                            mindreaderOpts: $.extend(leOpts.mindreaderOpts, {
                                selectFn: function(event, item) {
                                    form.getListeditor('specialties').addEntry(item);
                                }
                            })
                        });
                    },
                    maxLength: 50,
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    infoText: 'Add a specialty...'
                },
                {
                    name: 'treatmentReason',
                    selector: ':input[name="treatmentReason"]',
                    infoText: 'Seeing pt for..',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                }
            ]
        });
        form.addButton('save', 'Add to Profile', function() {
            saveFn(form, parent);
            el8.util.amplitude.logCareTeamAddToProfile({action: CARE_TEAM_ACTIONS.addToProfile, source: "Care Team"});
        }, true);
        form.addDiscardButton(function() {
            hideNewProviderForm(null, parent);
            el8.util.amplitude.logCareTeamAddToProfile({action: CARE_TEAM_ACTIONS.discardAdd, source: "Care Team"});
        });
        form.render();

        $('.specialty-field', $container).hide();
        form.getContainer().on('change', ':input[name="name"]',  function() {
            // hide specialty if we have an ID or the field is empty; show it for manual names
            if (form.getClickItemId('name') || !form.getVal('name')) {
                $('.specialty-field', $container).hide();
                form.getListeditor('specialties').reset();
            } else {
                $('.specialty-field', $container).show();
                form.getListeditor('specialties').$input.focusFocus();
            }
        });
    }

    function saveFn(form, parent) {
        var validateFn = function() {
            if (!form.getVal('name')) {
                return {result: false, msg: 'Please specify a name for the provider.'};
            }
            var specialtyIds = _.pluck(form.getListeditor('specialties').getAllEntries(), 'id');
            if (specialtyIds.length && specialtyIds.indexOf(null) !== -1) {
                return {result: false, msg: 'Please choose specialties from autocomplete.'};
            }
            return {result: true};
        };

        var validated = validateFn();
        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            return;
        }
        var mapped = form.getMapped(true, true);

        $('#' + parent + '-form-holder').addClass('el8Loading');
        var physicianId = form.getClickItemId('name');

        var specialtyIds = _.pluck(form.getListeditor('specialties').getAllEntries(), 'id');
        if (specialtyIds.length) { mapped['specialty_ids'] = specialtyIds; }
        delete mapped['specialties'];

        el8.ptdata.ptProviders.createMainProvider({
            physicianId: physicianId,
            data: mapped,
            successCb: function(item) {
                hideNewProviderForm(item, parent);
            }
        });
    }

    function hideNewProviderForm(newProvider, parent) {
        if (newProvider) { el8.ptdata.ptProviders.trigger('MOVED_MAIN', newProvider.getId()); }
        $('.add-provider-trigger', $('#' + parent + '-section')).show();
        var $container = $('#' + parent + '-form-holder');
        $container.empty().removeClass('el8Loading');
    }

    function getCareTeamActionsMenu (item) {
        var menu = el8.appchart.providers.main.getCareTeamMemberActionMenu(item);
        menu.push({
            actionText: 'Export to Note',
            actionFn: function() {
                el8.appchart.mgr.notes.addText(item.getNoteSummary(), 'data');
                el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.exportNote, providerId: item.getPhysicianId(), source:"Care Team"});
            }
        });
        return menu;
    }

    function getProvidersActionsMenu (item) {
        var menu = el8.appchart.providers.main.getProviderActionMenu(item);
        menu.push({
            actionText: 'Export to Note',
            actionFn: function() {
                el8.appchart.mgr.notes.addText(item.getNoteSummary(), 'data');
                el8.util.amplitude.logCareActionForPLRClinics({action: CARE_TEAM_ACTIONS.exportNote, providerId: item.getPhysicianId(), source:"Care Team"});
            }
        });
        return menu;
    }

    // render the field, which doesn't exist yet and then init it
    function addInitTreatmentReasonField($providerEntry, providerId) {
        var provider = el8.ptdata.ptProviders.getById(providerId);
        $('.treating-note-holder', $providerEntry).replaceWith(
            el8.template.appchart.refpanel.providers.treatingNoteField({ id: providerId })
        );
        var $elt = $('.treating-note-field', $providerEntry);
        clickTexts[providerId] = initTreatmentReasonField($elt, provider);
    }
    // just init the field, which has already been rendered
    function initTreatmentReasonField($elt, provider) {
        return (new el8.uiwidget.ClickText({
            maxLength: 300,
            changeFn: function(text) {
                provider.saveTreatmentReason(text);
            }
        })).init({
            elt: $elt,
            initText: provider.getTreatmentReason()
        });
    }

    // Same pair of function as above, but for care team
    // render the field, which doesn't exist yet and then init it
    function addInitCareTeamNoteField($providerEntry, providerId) {
        var provider = el8.ptdata.careTeamProviders.getById(providerId);
        $('.care-team-note-holder', $providerEntry).replaceWith(
            el8.template.appchart.refpanel.providers.careTeamMemberNote({ id: providerId })
        );
        var $elt = $('.care-team-note-field', $providerEntry);
        clickTexts[providerId] = initCareTeamNoteField($elt, provider);
    }
    // just init the field, which has already been rendered
    function initCareTeamNoteField($elt, careTeamProvider) {
        return (new el8.uiwidget.ClickText({
            maxLength: 300,
            changeFn: function(text) {
                careTeamProvider.saveProviderNote(text);
            }
        })).init({
            elt: $elt,
            initText: careTeamProvider.getNote()
        });
    }
})();
